import React, { useRef } from 'react';
import ModalPortal from '../../../../components/ModalPortal';

/**
 * Modal wrapper component
 * Handles overlay click-to-close behavior consistently
 */
export default function Modal({ isOpen, onClose, children, className = '', overlayClassName = '', contentStyle = {} }) {
    const overlayRef = useRef(null);

    if (!isOpen) return null;

    const handleMouseDown = (e) => {
        if (e.target === e.currentTarget) {
            const mouseDownOnOverlay = { current: true };
            e.currentTarget.addEventListener('mouseup', () => {
                if (mouseDownOnOverlay.current) onClose();
            }, { once: true });
        }
    };

    return (
        <ModalPortal>
            <div
                className={`modal-overlay ${overlayClassName}`}
                ref={overlayRef}
                onMouseDown={handleMouseDown}
            >
                <div 
                    className={`modal-content ${className}`}
                    onClick={e => e.stopPropagation()}
                    style={contentStyle}
                >
                    {children}
                </div>
            </div>
        </ModalPortal>
    );
}
